import { createSlice } from "@reduxjs/toolkit"

// Define initial state for the slice.
const initialState = {
  providerStock: { error: null, loading: false, data: [] },
  ProviderIps: { error: null, loading: false, data: [] },
  ProviderItemCategoires: { error: null, loading: false, data: [] },
  ProviderCommodityClassifications: { error: null, loading: false, data: [] },
  ProviderFundCodes: { error: null, loading: false, data: [] },
  ProviderShipments: { error: null, loading: false, data: [] },
  ProviderCurrencies: { error: null, loading: false, data: [] },
  ProviderItems: { error: null, loading: false, data: [] },
  ProviderInItems: { data: [], error: null, loading: null },
  ProviderOtherSourceItems: { data: [], error: null, loading: null },
  ProviderExchangeItems: { data: [], error: null, loading: null },
  ProviderAdjustmentIncreaseItems: { data: [], error: null, loading: null },
  ProviderAdjustmentDecreaseItems: { data: [], error: null, loading: null },
  ProviderOutItems: { data: [], error: null, loading: null },
  providerIpsStock: { error: null, loading: false, data: [] },
  providerIpsStockExport: { error: null, loading: false },
  providerWarehouses: { error: null, loading: false, data: [] },
  providerProviders: { error: null, loading: false, data: [] },
  providerProvinces: { error: null, loading: false, data: [] },
  providerFacilities: { error: null, loading: false, data: [] },
  providerProjects: { error: null, loading: false, data: [] },
  providerToProviderPendingCount: 0,
  realtime: {
    config: { loading: false, error: null, data: null },
    summary: { loading: false, error: null, data: null },
    stock: { loading: false, error: null, data: null },
    receipts: { loading: false, error: null, data: null },
    distributions: { loading: false, error: null, data: null },
    consumption: { loading: false, error: null, data: null },
    chart: {
      loading: false,
      error: null,
      data: null,
      type: null,
      dataset: null,
      metric: null,
      hasData: false,
    },
    provinceMap: {
      loading: false,
      error: null,
      data: null,
      type: "receipt",
    },
    exportState: { loading: false, error: null },
  },
  sectionChartData: {
    bar: { loading: false, error: null, data: null, dataset: 'stock', hasData: false },
    line: { loading: false, error: null, data: null, dataset: 'stock', hasData: false },
    pie: { loading: false, error: null, data: null, dataset: 'stock', hasData: false },
    map: { loading: false, error: null, data: null, type: 'receipt', hasData: false },
    table: { loading: false, error: null, data: null },
    stackedBar: { loading: false, error: null, data: null, dataset: 'stock', hasData: false },
  },
}

//  Define slice and it's reducer functions.
const providerDashboardSlice = createSlice({
  name: "providerDashboard",
  initialState,
  reducers: {
    setProviderStock(state, action) {
      state.providerStock = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      }
    },
    setProviderIps(state, action) {
      state.ProviderIps = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      }
    },
    setProviderItemCategories(state, action) {
      state.ProviderItemCategoires = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      }
    },
    setProviderCommodityClassifications(state, action) {
      state.ProviderCommodityClassifications = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      }
    },
    setProviderFundCodes(state, action) {
      state.ProviderFundCodes = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      }
    },
    setProviderShipments(state, action) {
      state.ProviderShipments = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      }
    },
    setProviderCurrencies(state, action) {
      state.ProviderCurrencies = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      }
    },
    setProviderToProviderPendingCount(state, action) {
      state.providerToProviderPendingCount = action.payload
    },
    setProviderItems(state, action) {
      state.ProviderItems = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      }
    },
    setProviderInItems(state, action) {
      state.ProviderInItems = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      }
    },
    setProviderOtherSourceItems(state, action) {
      state.ProviderOtherSourceItems = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      }
    },
    setProviderExchangeItems(state, action) {
      state.ProviderExchangeItems = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      }
    },
    setProviderAdjustmentIncreaseItems(state, action) {
      state.ProviderAdjustmentIncreaseItems = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      }
    },
    setProviderAdjustmentDecreaseItems(state, action) {
      state.ProviderAdjustmentDecreaseItems = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      }
    },
    setProviderOutItems(state, action) {
      state.ProviderOutItems = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      }
    },
    setProviderIpsStock(state, action) {
      state.providerIpsStock = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      }
    },
    setProviderIpsStockExport(state, action) {
      state.providerIpsStockExport = {
        error: action.payload.error,
        loading: action.payload.loading,
      }
    },
    setProviderWarehouses(state, action) {
      state.providerWarehouses = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      }
    },
    setProviderProviders(state, action) {
      state.providerProviders = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      }
    },
    setProviderProvinces(state, action) {
      state.providerProvinces = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      }
    },
    setProviderFacilities(state, action) {
      state.providerFacilities = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      }
    },
    setProviderProjects(state, action) {
      state.providerProjects = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      }
    },
    resetProviderStock(state) {
      state.providerStock = { error: null, loading: false, data: [] }
    },
    resetProviderIps(state) {
      state.ProviderIps = { error: null, loading: false, data: [] }
    },
    resetProviderItemCategories(state) {
      state.ProviderItemCategoires = { error: null, loading: false, data: [] }
    },
    resetProviderCurrencies(state) {
      state.ProviderCurrencies = { error: null, loading: false, data: [] }
    },
    resetProviderItems(state) {
      state.ProviderItems = { error: null, loading: false, data: [] }
    },
    resetProviderInItems(state) {
      state.ProviderInItems = { data: [], error: null, loading: null }
    },
    resetProviderOtherSourceItems(state) {
      state.ProviderOtherSourceItems = { data: [], error: null, loading: null }
    },
    resetProviderExchangeItems(state) {
      state.ProviderExchangeItems = { data: [], error: null, loading: null }
    },
    resetProviderAdjustmentIncreaseItems(state) {
      state.ProviderAdjustmentIncreaseItems = { data: [], error: null, loading: null }
    },
    resetProviderAdjustmentDecreaseItems(state) {
      state.ProviderAdjustmentDecreaseItems = { data: [], error: null, loading: null }
    },
    resetProviderOutItems(state) {
      state.ProviderOutItems = { data: [], error: null, loading: null }
    },
    resetProviderIpsStock(state) {
      state.providerIpsStock = { data: [], error: null, loading: null }
    },
    resetProviderWarehouses(state) {
      state.providerWarehouses = { data: [], error: null, loading: null }
    },
    resetProviderProviders(state) {
      state.providerProviders = { data: [], error: null, loading: null }
    },
    resetProviderProvinces(state) {
      state.providerProvinces = { data: [], error: null, loading: null }
    },
    resetProviderFacilities(state) {
      state.providerFacilities = { data: [], error: null, loading: null }
    },
    resetProviderProjects(state) {
      state.providerProjects = { data: [], error: null, loading: null }
    },
    resetProviderIPsStockExport(state) {
      state.providerIpsStockExport = { error: null, loading: false }
    },
    setRealtimeConfig(state, action) {
      state.realtime.config = action.payload
    },
    setRealtimeSummary(state, action) {
      state.realtime.summary = action.payload
    },
    setRealtimeStock(state, action) {
      state.realtime.stock = action.payload
    },
    setRealtimeReceipts(state, action) {
      state.realtime.receipts = action.payload
    },
    setRealtimeDistributions(state, action) {
      state.realtime.distributions = action.payload
    },
    setRealtimeConsumption(state, action) {
      state.realtime.consumption = action.payload
    },
    setRealtimeChart(state, action) {
      state.realtime.chart = action.payload
    },
    setProvinceMap(state, action) {
      state.realtime.provinceMap = action.payload
    },
    setRealtimeExportState(state, action) {
      state.realtime.exportState = action.payload
    },
    setSectionChartData(state, action) {
      const { section } = action.payload
      if (section && state.sectionChartData[section] !== undefined) {
        state.sectionChartData[section] = {
          ...state.sectionChartData[section],
          ...action.payload,
        }
      }
    },
    resetSectionChartData(state, action) {
      const section = action.payload
      if (section && state.sectionChartData[section] !== undefined) {
        const defaults = {
          bar: { loading: false, error: null, data: null, dataset: 'stock', hasData: false },
          line: { loading: false, error: null, data: null, dataset: 'stock', hasData: false },
          pie: { loading: false, error: null, data: null, dataset: 'stock', hasData: false },
          map: { loading: false, error: null, data: null, type: 'receipt', hasData: false },
          table: { loading: false, error: null, data: null },
          stackedBar: { loading: false, error: null, data: null, dataset: 'stock', hasData: false },
        }
        state.sectionChartData[section] = defaults[section] || { loading: false, error: null, data: null }
      }
    },
  },
})

export const providerDashboardAction = providerDashboardSlice.actions

export default providerDashboardSlice
